import { DEFAULT_SORT_COLUMN_ID } from '../../components/Table/columnsConfig';

import type { PokerMultiTableTournamentsStateBase } from './types';

export const defaultState: PokerMultiTableTournamentsStateBase = {
  activeFilters: {},
  filtersData: { RM: [], PM: [] },
  filtersError: '',
  isLoading: false,
  preloaded: false,
  selectedTournamentId: 0,
  subscriptionError: '',
  tableFilters: [],
  tableRowsCount: 0,
  tableSortRule: { id: DEFAULT_SORT_COLUMN_ID, desc: false },
  tournamentsCount: 0,
  tournamentsData: {},
  tournamentsError: '',
  tournamentsCurrency: 'MULTIPLE'
};
